// Generated by CoffeeScript 1.12.7
(function () {
  require('../base');

  (function ($) {
    return $.widget('bijou.infoBoxSet', $.bijou.base, {
      options: {
        boxSelector: '.info-box',
        toggleSelector: '.info-box-toggle',
        activeClass: 'info-box-active',
        contentSelector: '.info-box-content',
        animate: false
      },
      _create: function () {
        this.boxes = this.element.find(this.options.boxSelector)
        this.activeBox = null
        return this.element.on('click', this.options.toggleSelector, (function (_this) {
          return function (e) {
            e.preventDefault()
            return _this.toggle($(e.currentTarget).closest(_this.options.boxSelector))
          }
        })(this))
      },
      show: function (box) {
        if (!(this.boxes.index(box) !== -1 && !this._isActive(box) && this._trigger('show', null, {
          box: box
        }))) {
          return
        }
        if (this.activeBox != null) {
          this.hide()
        }

        this.activeBox = box.addClass(this.options.activeClass)
        if (this.options.animate) {
          box.find(this.options.contentSelector).slideDown()
        }
        return this._trigger('shown', null, {
          box: box
        })
      },
      hide: function (box) {
        var _this = this
        if (box == null) {
          box = this.activeBox
        }
        if (!(this._isActive(box) && this._trigger('hide', null, {
          box: box
        }))) {
          return
        }
        if (this.options.animate) {
          box.find(this.options.contentSelector).slideUp({
            complete: function () {
              box.removeClass(_this.options.activeClass)
            }
          })
        } else {
          box.removeClass(this.options.activeClass)
        }
        this.activeBox = null
        return this._trigger('hidden', null, {
          box: box
        })
      },
      toggle: function (box) {
        if (this._isActive(box)) {
          return this.hide(box)
        } else {
          return this.show(box)
        }
      },
      _isActive: function (box) {
        return (this.activeBox != null) && this.activeBox.is(box)
      }
    })
  })(window.jQuery)
}).call(this)
